export default "__VITE_ASSET__a5222432__"